module.exports = __webpack_public_path__ + "img/no_img.b81f6016.png";